import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AppShell } from "./app-shell";
import { ErrorBoundary } from "./components/error-boundary";
import { SessionProvider } from "./lib/use-session";
import "./styles.css";

/**
 * Rejestracja workera serwisowego.
 *
 * Wyłącznie po to, żeby Chrome uznał aplikację za instalowalną — worker nie
 * cachuje niczego (powody w `public/sw.js`). Po `load`, bo rejestracja w trakcie
 * wczytywania konkuruje o łącze z pierwszym renderem.
 *
 * Porażka jest bez znaczenia: aplikacja działa identycznie bez workera, traci
 * tylko możliwość instalacji. Dlatego bez komunikatu dla użytkownika.
 */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}

const container = document.getElementById("root");
if (!container) throw new Error("Brak #root w index.html");

/**
 * Granica błędu jest NAJDALEJ na zewnątrz, poza routerem i sesją.
 *
 * Wewnątrz łapałaby wyłącznie ekrany, a wywrócić się może również wczytywanie
 * sesji albo sam router — i wtedy biała strona wracałaby mimo granicy. Cena za
 * to jest jedna: gałąź awaryjna nie ma dostępu do routera, więc powrót idzie
 * zwykłym `<a href>`, a nie `<Link>`. To zamierzone — im mniej ta gałąź zależy
 * od reszty aplikacji, tym większa szansa, że w ogóle się narysuje.
 */
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <SessionProvider>
          <AppShell />
        </SessionProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
